import React, { Component } from 'react';

import Aux from '../Aux/Aux';
import classes from './Layout.module.css';

export interface LayoutProps {}
export interface LayoutState { showSideDrawer: boolean }

class Layout extends Component<LayoutProps, LayoutState> {
    state = {
        showSideDrawer: false
    }

    sideDrawerClosedHandler = () => {
        this.setState( { showSideDrawer: false } );
    }

    sideDrawerToggleHandler = () => {
        this.setState( ( prevState ) => {
            return { showSideDrawer: !prevState.showSideDrawer };
        } );
    }

    render () {
        return (
            <Aux>
                <main className={classes.Content}>
                    {this.props.children}
                </main>
            </Aux>
        )
    }
}

export default Layout;
